import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { EChartOption } from 'echarts';
import { IPens, IAxisSetting, IConfig } from './../../index';
import './tuning-graph.css';

export interface IRefs {
    chartRef: React.RefObject<any>;
    scrollRefX: React.RefObject<HTMLDivElement>;
    scrollRefY: React.RefObject<HTMLDivElement>;
}

interface IGraph {
    refs: IRefs;
    data: any;
    pens: IPens[];
    config: IConfig;
    parentID: string;
    newSeriesPoints: any[];
    echarts_react?: any;
    notMerge?: boolean;
    calbacUpdateRow?: any;
    id?: string;
    intervalOnOff?: boolean;
    onChartRef: (ref: any) => void;
    SetInterval: (check: boolean) => void;
}

export interface TrendHandle {
    handleReduceTimeAxis?: () => void;
}

const TuningGraph = React.forwardRef<TrendHandle, IGraph>((props, forwardedRef) => {
    const {
        refs,
        data,
        pens,
        config,
        parentID,
        echarts_react,
        notMerge,
        calbacUpdateRow,
        id,
        intervalOnOff,
        onChartRef
    } = props;

    const dataline = {
        name: '',
        type: 'line',
        step: false,
        symbol: 'none',
        showSymbol: true,
        symbolSize: 3,
        lineStyle: { color: '#000', width: 1 },
        large: true,
        data: [],
        label: {},
        animation: false,
        markPoint: {}
    };

    const refDiv = React.useRef<HTMLDivElement>(null);
    const dataZoomRef = React.useRef<EChartOption.DataZoom[] | null>(null);
    const seriesRef = React.useRef<{}>();

    const option_def: EChartOption = {
        grid: {
            right: 0,
            top: 0,
            bottom: 20,
            left: 0,
            show: true,
            backgroundColor: '#000'
        },
        brush: {
            toolbox: [],
            xAxisIndex: 'all',
            brushLink: 'all',
            outOfBrush: {
                colorAlpha: 0.2
            },
            throttleType: 'debounce'
        },
        xAxis: {
            type: 'time',
            silent: false,
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#0002fd'
                }
            },
            splitArea: {
                show: false
            }
        }
    };

    const [option, setOption] = React.useState<EChartOption>({});

    const [zoomStartEnd, setZoomStartEnd] = React.useState({
        startX: 0,
        endX: 100,
        startY: 0,
        endY: 100
    });

    React.useEffect(() => {
        let getOption = () => {
            let newOption = option.grid ? option : option_def;
            let seriesall: any[] = [];
            let yAxisArr: any = [];
            let dataZoomArr: EChartOption.DataZoom[] = [];
            let AxisIndex: number[] = [];

            let colors: string[] = [];

            let namesLegend = [];

            let formatterData = function (a: any) {
                return a.toFixed(1).toLocaleString();
            };

            for (let i = 0; i < props.pens.length; i++) {
                if (props.pens[i].name != '' && props.pens[i].enable) {
                    let seriestemp = JSON.parse(JSON.stringify(dataline));

                    let name = props.pens[i].name;
                    if (name.indexOf('.MODE') != -1 || name.indexOf('.STATE') != -1) {
                    }

                    if (props.data[name] && props.pens[i].enable) {
                        seriestemp.data = props.data[name];
                    } else {
                        seriestemp.data = [];
                    }

                    seriestemp.name = name;

                    namesLegend.push(name);

                    seriestemp.lineStyle.color = props.pens[i].color;

                    colors.push(props.pens[i].color);

                    if (props.pens[i].selected) {
                        seriestemp.lineStyle.width = 3;
                        seriestemp.symbolSize = 4;
                    }

                    seriestemp.yAxisIndex =
                        props.pens[i].yAxisIndex != null ? props.pens[i].yAxisIndex : yAxisArr.length;
                    AxisIndex.push(seriestemp.yAxisIndex);

                    switch (props.pens[i].typeLine) {
                        case 'line': {
                            seriestemp.type = 'line';
                            break;
                        }
                        case 'linePoint': {
                            seriestemp.type = 'line';
                            seriestemp.symbol = 'circle';
                            seriestemp.symbolSize = props.pens[i].selected ? 12 : 10;
                            seriestemp.itemStyle = { color: props.pens[i].color };
                            break;
                        }
                        case 'point': {
                            seriestemp.type = 'scatter';
                            seriestemp.symbolSize = props.pens[i].selected ? 12 : 10;
                            seriestemp.symbol = 'circle';
                            seriestemp.lineStyle.opacity = 0;
                            seriestemp.itemStyle = { color: props.pens[i].color };
                            break;
                        }
                        case 'step': {
                            seriestemp.type = 'line';
                            seriestemp.step = 'end';
                            break;
                        }
                        case 'areadiscrete': {
                            seriestemp.type = 'line';
                            seriestemp.step = 'end';
                            seriestemp.symbol = 'none';
                            seriestemp.lineStyle.opacity = 0;
                            seriestemp.areaStyle = {
                                color: props.pens[i].color
                            };
                            break;
                        }
                        case 'radar': {
                            seriestemp.type = 'radar';
                            break;
                        }
                    }

                    seriestemp.encode = { x: 0, y: 1 };

                    seriestemp.label = {
                        show: false
                    };

                    seriesall.push(seriestemp);

                    if (props.pens[i].typeLine != 'radar' && seriestemp.yAxisIndex == yAxisArr.length) {
                        let formatterY = formatterData;

                        let yAxis = {
                            scrollbar: {
                                show: true
                            },
                            type: 'value',
                            min: Number(props.pens[i].min),
                            max: Number(props.pens[i].max),
                            axisLabel: {
                                show: false,
                                margin: 10,
                                fontSize: 16,
                                formatter: formatterY
                            },
                            axisLine: {
                                show: i > 0 ? false : true,
                                lineStyle: {
                                    color: props.pens[i].color
                                }
                            },
                            splitLine: {
                                show: i > 0 ? false : true,
                                interval: 4,
                                lineStyle: {
                                    color: '#0002fd'
                                }
                            },
                            show: true,
                            position: 'left',
                            animation: false,
                            offset: 0
                        };

                        yAxisArr.push(yAxis);
                    } else {
                        yAxisArr[seriestemp.yAxisIndex].min = Math.min(
                            yAxisArr[seriestemp.yAxisIndex].min,
                            Number(props.pens[i].min)
                        );
                        yAxisArr[seriestemp.yAxisIndex].max = Math.max(
                            yAxisArr[seriestemp.yAxisIndex].max,
                            Number(props.pens[i].max)
                        );
                    }
                }
            }

            let yAxisNumArr: number[] = [];

            for (let i = 0; i < seriesall.length; i++) {
                yAxisNumArr.push(i);
            }

            if (yAxisArr.length == 0) {
                yAxisArr = { type: 'value' };
            }

            let hasSlider = true;
            if (yAxisNumArr.length != 0) {
                if (hasSlider) {
                }
            }

            let typeX =
                (props.config.settings.chart.xAxis as IAxisSetting) != undefined
                    ? ((props.config.settings.chart.xAxis as IAxisSetting).type as any)
                    : 'time';

            let formatterX = undefined;
            if (typeX != 'time') {
                formatterX = formatterData;
            }

            if ((props.config.settings.chart.xAxis as IAxisSetting)?.name) {
                if (newOption.grid) {
                    let name = (props.config.settings.chart.xAxis as IAxisSetting)?.name;
                    let nameLength = name?.length;
                    let rightValue = 25;

                    if (nameLength) {
                        rightValue += nameLength * 6;
                    }

                    newOption.grid = {
                        right: rightValue
                    };
                }
            }

            const containerRectX = refs.scrollRefX.current?.parentElement;
            const containerRectY = refs.scrollRefY.current?.parentElement;
            const scrollWidth = refs.scrollRefX.current?.clientWidth;
            const scrollHeight = refs.scrollRefY.current?.clientHeight;
            const containerWidth = containerRectX?.offsetWidth || 0;
            const containerHeight = containerRectY?.offsetHeight || 0;
            let zoomPosition = { startX: 0, startY: 100, endX: 0, endY: 100 };

            // Расчет начального положения скроллов и задание dataZoom
            if (scrollWidth && scrollHeight) {
                const initialXPosition = containerWidth - scrollWidth;
                const initialYPosition = (containerHeight - scrollHeight) / 2;
                if (refs.scrollRefX.current && refs.scrollRefY.current) {
                    refs.scrollRefX.current.style.left = `${initialXPosition}px`;
                    refs.scrollRefY.current.style.top = `${initialYPosition}px`;
                    const LeftScrollConteiner = containerRef?.current?.clientHeight;
                    if (LeftScrollConteiner) {
                        const Leftscroll = containerRef?.current?.querySelector('.scroll-y') as HTMLElement;
                        const scrollYHeight = Leftscroll.offsetHeight;

                        let init = (LeftScrollConteiner - scrollYHeight) / 2;

                        setScrollYPosition(init);
                    }
                }

                zoomPosition.startX = (initialXPosition / containerWidth) * 100;
                zoomPosition.endX = ((initialXPosition + scrollWidth) / containerWidth) * 100;
                zoomPosition.startY = ((containerHeight - initialYPosition - scrollHeight) / containerHeight) * 100;
                zoomPosition.endY = ((containerHeight - initialYPosition) / containerHeight) * 100;

                setZoomStartEnd({
                    startX: zoomPosition.startX,
                    endX: zoomPosition.endX,
                    startY: zoomPosition.startY,
                    endY: zoomPosition.endY
                });

                props.SetInterval(true);
            }

            dataZoomArr = [
                {
                    start: zoomPosition.startX,
                    end: zoomPosition.endX,
                    xAxisIndex: 0,
                    show: false,
                    filterMode: 'none'
                },
                {
                    start: zoomPosition.startY,
                    end: zoomPosition.endY,
                    yAxisIndex: AxisIndex,
                    show: false,
                    filterMode: 'none'
                }
            ];

            newOption = {
                ...newOption,
                backgroundColor: '#000',
                animation: false,
                color: colors,
                toolbox: { show: false },
                grid: {
                    ...newOption.grid
                    // left: yAxisArr.length * 100
                },
                radar: props.config.settings.chart.radar,
                xAxis: {
                    ...newOption.xAxis,
                    axisLabel: {
                        show: true,
                        formatter: formatterX,
                        color: '#ffffff'
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#0001b2'
                        }
                    },
                    name: (props.config.settings.chart.xAxis as IAxisSetting)?.name,
                    // min: xAxis.min,
                    min: (props.config.settings.chart.xAxis as IAxisSetting)?.min,
                    max: (props.config.settings.chart.xAxis as IAxisSetting)?.max,
                    type: typeX
                },
                dataZoom: dataZoomArr,
                yAxis: yAxisArr,
                series: seriesall
            };

            seriesRef.current = newOption.xAxis;

            return newOption;
        };
        setOption(getOption());
        // }
    }, []);

    // Обновление и перестроение данных в графике
    React.useEffect(() => {
        const echartsInstance = refs.chartRef?.current.getEchartsInstance();
        let currentOptions = echartsInstance.getOption();

        for (let i = 0; i < props.pens.length; i++) {
            if (props.pens[i].name != '' && props.pens[i].enable) {
                if (currentOptions.yAxis && currentOptions.xAxis) {
                    if (props.intervalOnOff) {
                        const now = new Date();
                        const currentTimeInMilliseconds = now.getTime();
                        currentOptions.xAxis[0].max = now;
                        currentOptions.xAxis[0].axisPointer.value = currentTimeInMilliseconds;
                    }

                    for (let key in props.newSeriesPoints) {
                        const newPoint = props.newSeriesPoints[key][0];
                        currentOptions.series[key].data.push(newPoint);
                    }
                }
            }
        }

        //Обновление размера скролла
        let min = (props.config.settings.chart.xAxis as IAxisSetting)?.min || '1970-01-01T00:00:00Z';
        let max = (props.config.settings.chart.xAxis as IAxisSetting)?.max || '1970-01-01T00:00:00Z';
        const xAxis = props.config.settings.chart.xAxis as IAxisSetting;
        xAxis.min = (props.config.settings.chart.xAxis as IAxisSetting)?.min;
        const minDate = new Date(min);
        const maxDate = new Date(max);
        const totalMilliseconds = maxDate.getTime() - minDate.getTime();
        const startTime = Number(refs.scrollRefX.current?.dataset.time);
        const maxTimeRange = Number(max) - Number(min);
        let endX = 100;
        let startX = 0;
        if (maxTimeRange < startTime) {
            if (xAxis) {
                xAxis.min = new Date(Number(xAxis.max) - startTime).toISOString();
            }
            startX = ((maxDate.getTime() - startTime - minDate.getTime()) / totalMilliseconds) * 100;
        } else {
            startX = ((maxDate.getTime() - startTime - minDate.getTime()) / totalMilliseconds) * 100;
        }
        if (refs.scrollRefX.current) {
            refs.scrollRefX.current.setAttribute('data-min', minDate.getTime().toString());
            refs.scrollRefX.current.setAttribute('data-max', maxDate.getTime().toString());
        }
        const startTimePercentage = (startTime / totalMilliseconds) * 100;
        const containerRectX = refs.scrollRefX.current?.parentElement;
        const containerWidth = containerRectX?.offsetWidth || 0;
        const scrollWidth = containerWidth * (startTimePercentage / 100);
        const scrollLeft = containerWidth * (startX / 100);
        if (refs.scrollRefX.current) {
            if (scrollWidth > containerWidth) {
                refs.scrollRefX.current.style.width = `${containerWidth}px`;
                refs.scrollRefX.current.style.left = `0px`;
            } else {
                refs.scrollRefX.current.style.width = `${scrollWidth}px`;
                refs.scrollRefX.current.style.left = `${scrollLeft}px`;
            }
        }

        if (currentOptions.dataZoom[0]) {
            currentOptions.dataZoom[0].start = startX;
            currentOptions.dataZoom[0].end = endX;
        }

        echartsInstance.setOption(currentOptions);
    }, [props.data]);

    const isDraggingX = React.useRef(false);
    const isDraggingY = React.useRef(false);
    const prevMouseY = React.useRef<number>(0);

    const prevMouseX = React.useRef<number>(0);

    // Горизонтальный скролл
    React.useEffect(() => {
        const iframe = document.getElementById(parentID) as HTMLIFrameElement | null;
        if (iframe && iframe.contentWindow) {
            const handleMouseDownX = (event: MouseEvent) => {
                event.preventDefault();
                // props.SetInterval(false)
                isDraggingX.current = true;
                prevMouseX.current = event.clientX;

                if (iframe.contentWindow) {
                    iframe.contentWindow.addEventListener('mousemove', handleMouseMoveX);
                    iframe.contentWindow.addEventListener('mouseup', handleMouseUpX);
                }
            };

            const handleMouseMoveX = (event: MouseEvent) => {
                event.preventDefault();
                if (isDraggingX.current && refs.scrollRefX.current) {
                    const containerRectX = refs.scrollRefX.current.parentElement;
                    const scrollWidth = refs.scrollRefX.current.clientWidth;
                    const containerWidth = containerRectX?.offsetWidth || 0;

                    let deltaX = event.clientX - prevMouseX.current;

                    let left = refs.scrollRefX.current.offsetLeft + deltaX;
                    left = Math.max(0, left);
                    left = Math.min(containerWidth - scrollWidth, left);
                    refs.scrollRefX.current.style.left = `${left}px`;

                    const startX = (left / containerWidth) * 100;
                    const endX = ((left + scrollWidth) / containerWidth) * 100;

                    if (refs.chartRef.current) {
                        const echartsInstance = refs.chartRef.current.getEchartsInstance();
                        echartsInstance.dispatchAction({
                            type: 'dataZoom',
                            start: startX,
                            end: endX,
                            dataZoomIndex: 0
                        });
                    }

                    prevMouseX.current = event.clientX;
                }
            };

            const handleMouseUpX = (event: MouseEvent) => {
                event.preventDefault();
                isDraggingX.current = false;

                if (iframe.contentWindow) {
                    iframe.contentWindow.removeEventListener('mousemove', handleMouseMoveX);
                    iframe.contentWindow.removeEventListener('mouseup', handleMouseUpX);
                }
            };

            if (refs.scrollRefX.current) {
                refs.scrollRefX.current.addEventListener('mousedown', handleMouseDownX);
            }

            return () => {
                if (refs.scrollRefX.current) {
                    refs.scrollRefX.current.removeEventListener('mousedown', handleMouseDownX);
                }
            };
        }
    }, [refs.scrollRefX, refs.chartRef]);

    const handleLeftClickX = () => {
        let scroll = 'scrollX';
        let button = 'left';
        SetScrollOption(scroll, button);
    };

    const handleRightClickX = () => {
        let scroll = 'scrollX';
        let button = 'right';
        SetScrollOption(scroll, button);
    };

    const [scrollYPosition, setScrollYPosition] = React.useState(0);

    // Вертикальный скролл
    React.useEffect(() => {
        const iframe = document.getElementById(parentID) as HTMLIFrameElement | null;
        if (iframe && iframe.contentWindow) {
            const handleMouseDownY = (event: MouseEvent) => {
                event.preventDefault();
                isDraggingY.current = true;
                prevMouseY.current = event.clientY;

                if (iframe.contentWindow) {
                    iframe.contentWindow.addEventListener('mousemove', handleMouseMoveY);
                    iframe.contentWindow.addEventListener('mouseup', handleMouseUpY);
                }
            };

            const handleMouseMoveY = (event: MouseEvent) => {
                event.preventDefault();
                if (isDraggingY.current && refs.scrollRefY.current) {
                    const containerRectY = refs.scrollRefY.current.parentElement;
                    const scrollHeight = refs.scrollRefY.current.offsetHeight;
                    const containerHeight = containerRectY?.offsetHeight || 0;

                    let deltaY = event.clientY - prevMouseY.current;

                    let top = refs.scrollRefY.current.offsetTop + deltaY;
                    // setScrollYPosition(top);
                    top = Math.max(0, top);
                    top = Math.min(containerHeight - scrollHeight, top);
                    refs.scrollRefY.current.style.top = `${top}px`;

                    leftScrollYPosition(top, scrollHeight, containerHeight);

                    const startY = ((containerHeight - top - scrollHeight) / containerHeight) * 100;
                    const endY = ((containerHeight - top) / containerHeight) * 100;

                    setZoomStartEnd((prevState) => ({
                        ...prevState,
                        startY: startY,
                        endY: endY
                    }));

                    if (refs.chartRef.current) {
                        const echartsInstance = refs.chartRef.current.getEchartsInstance();

                        echartsInstance.dispatchAction({
                            type: 'dataZoom',
                            start: startY,
                            end: endY,
                            dataZoomIndex: 1
                        });
                    }

                    prevMouseY.current = event.clientY;
                }
            };

            const handleMouseUpY = (event: MouseEvent) => {
                event.preventDefault();
                isDraggingY.current = false;

                if (iframe.contentWindow) {
                    iframe.contentWindow.removeEventListener('mousemove', handleMouseMoveY);
                    iframe.contentWindow.removeEventListener('mouseup', handleMouseUpY);
                }
            };

            if (refs.scrollRefY.current) {
                refs.scrollRefY.current.addEventListener('mousedown', handleMouseDownY);
            }

            return () => {
                if (refs.scrollRefY.current) {
                    refs.scrollRefY.current.removeEventListener('mousedown', handleMouseDownY);
                }
            };
        }
    }, [refs.scrollRefY, refs.chartRef]);

    const handleUpClickY = () => {
        let scroll = 'scrollY';
        let button = 'up';
        SetScrollOption(scroll, button);
    };

    const handleDownClickY = () => {
        let scroll = 'scrollY';
        let button = 'down';
        SetScrollOption(scroll, button);
    };

    const SetScrollOption = (scroll: any, button: any) => {
        if (refs.chartRef.current && refs.scrollRefY.current && refs.scrollRefX.current) {
            let start: any;
            let end: any;
            switch (scroll) {
                case 'scrollX':
                    const containerRectX = refs.scrollRefX.current.parentElement;
                    const scrollWidth = refs.scrollRefX.current.clientWidth;
                    const containerWidth = containerRectX?.offsetWidth || 0;

                    if (button == 'left') {
                        refs.scrollRefX.current.style.left =
                            Math.max(0, parseInt(refs.scrollRefX.current.style.left) - 20) + 'px';
                    } else if (button == 'right') {
                        refs.scrollRefX.current.style.left =
                            Math.min(containerWidth - scrollWidth, parseInt(refs.scrollRefX.current.style.left) + 20) +
                            'px';
                    }

                    const left = parseInt(refs.scrollRefX.current.style.left);

                    start = (left / containerWidth) * 100;
                    end = ((left + scrollWidth) / containerWidth) * 100;

                    break;

                case 'scrollY':
                    const containerRectY = refs.scrollRefY.current.parentElement;
                    const scrollHeight = refs.scrollRefY.current.clientHeight;
                    const containerHeight = containerRectY?.offsetHeight || 0;

                    if (button == 'up') {
                        let top = Math.max(0, parseInt(refs.scrollRefY.current.style.top) - 20);
                        refs.scrollRefY.current.style.top = top + 'px';
                        // setScrollYPosition(top);
                        leftScrollYPosition(top, scrollHeight, containerHeight);
                    } else if (button == 'down') {
                        let top = Math.min(
                            containerHeight - scrollHeight,
                            parseInt(refs.scrollRefY.current.style.top) + 20
                        );
                        refs.scrollRefY.current.style.top = top + 'px';
                        // setScrollYPosition(top);
                        leftScrollYPosition(top, scrollHeight, containerHeight);
                    }

                    const top = parseInt(refs.scrollRefY.current.style.top);

                    start = ((containerHeight - top - scrollHeight) / containerHeight) * 100;
                    end = ((containerHeight - top) / containerHeight) * 100;

                    setZoomStartEnd((prevState) => ({
                        ...prevState,
                        startY: start,
                        endY: end
                    }));

                    break;

                default:
                    break;
            }

            const echartsInstance = refs.chartRef.current.getEchartsInstance();

            const dataZoom = echartsInstance.getOption().dataZoom;
            if (dataZoom) {
                let index;
                if (scroll == 'scrollX') {
                    index = 0;
                } else if (scroll == 'scrollY') {
                    index = 1;
                }

                echartsInstance.dispatchAction({
                    type: 'dataZoom',
                    start: start,
                    end: end,
                    dataZoomIndex: index
                });
            }
        }
    };

    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const mutationObserver = new MutationObserver(() => {
            const containerRectX = refs.scrollRefX.current?.parentElement;
            const containerWidth = containerRectX?.offsetWidth || 0;
            if (refs.scrollRefX.current?.offsetWidth) {
                const iframe = document.getElementById(parentID) as HTMLIFrameElement | null;
                let input = iframe?.contentDocument?.getElementById('input6');

                let leftPosition = containerWidth - refs.scrollRefX.current?.offsetWidth;

                if (refs.scrollRefX.current?.offsetLeft === leftPosition + 2) {
                    props.SetInterval(true);
                    if (input) {
                        input.style.borderStyle = 'solid';
                        input.style.borderWidth = '1px 2px 2px 1px';
                        input.style.borderColor = '#ffffff #404040 #404040 #ffffff';

                        input.setAttribute('pause', 'false');
                    }
                } else {
                    props.SetInterval(false);
                    if (input) {
                        input.style.borderStyle = 'solid';
                        input.style.borderWidth = '2px 1px 1px 2px';
                        input.style.borderColor = '#404040 #ffffff #ffffff #404040';

                        input.setAttribute('pause', 'true');
                    }
                }
            }
        });

        if (refs.scrollRefX.current) {
            mutationObserver.observe(refs.scrollRefX.current, {
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        }

        return () => {
            mutationObserver.disconnect();
        };
    }, []);

    function leftScrollYPosition(top: number, scrollHeight: number, containerHeight: number) {
        const scrollElemContainer = containerRef?.current?.offsetHeight;
        if (scrollElemContainer) {
            const scrollYElement = containerRef?.current?.querySelector('.scroll-y') as HTMLElement;
            const scrollYLeftHeight = scrollYElement.offsetHeight;

            let koef = (containerHeight - scrollHeight) / containerHeight;
            // let koef = (scrollYLeftHeight - scrollHeight) / (scrollYLeftHeight);

            setScrollYPosition(top / (koef - 0.05) - scrollYLeftHeight / 2);
        }
    }

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 20px)' }}>
                <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                    <div
                        ref={containerRef}
                        className="visible-scroll-container"
                        style={{ height: 'calc(100% - 20px)', width: '15px', overflow: 'hidden' }}>
                        <div
                            id="scroll-y"
                            className="scroll-y"
                            style={{
                                height: '100%',
                                width: '100%',
                                background: `${props.pens[0].color}`,
                                position: 'relative',
                                top: `${scrollYPosition}px`
                            }}></div>
                    </div>
                    <div style={{ width: '100%', height: '100%' }}>
                        <ReactEcharts
                            notMerge={props.notMerge}
                            lazyUpdate={true}
                            option={option}
                            style={{ height: '100%', width: '100%' }}
                            ref={refs.chartRef}
                            opts={{ locale: '' }}
                        />
                    </div>
                    <div className="scroll-y-container" style={{ marginBottom: '15px' }}>
                        <button className="up-scroll-button" onClick={handleUpClickY}>
                            <svg width="6" height="6" viewBox="0 0 6 6">
                                <polygon points="0,6 3,0 6,6" fill="black" />
                            </svg>
                        </button>
                        <div
                            className="main-scroll-y"
                            style={{ height: 'calc(100% - 30px)', width: '100%', position: 'relative' }}>
                            <div
                                id="scrollRefY"
                                data-percent={50}
                                className="scroll-y-drag"
                                ref={refs.scrollRefY}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    height: '50%',
                                    width: '13px',
                                    background: '#d4d0c8',
                                    cursor: 'pointer'
                                }}></div>
                        </div>
                        <button className="down-scroll-button" onClick={handleDownClickY}>
                            <svg width="6" height="6" viewBox="0 0 6 6">
                                <polygon points="0,0 3,6 6,0" fill="black" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="scroll-x-container" style={{ width: 'calc(100% - 30px)', margin: '0px 15px' }}>
                    <button className="left-scroll-button" onClick={handleLeftClickX}>
                        <svg width="6" height="6" viewBox="0 0 6 6">
                            <polygon points="0,3 6,0 6,6" fill="black" />
                        </svg>
                    </button>
                    <div className="main-scroll-x" style={{ width: 'calc(100% - 30px)', position: 'relative' }}>
                        <div
                            id="scrollRefX"
                            data-time={360000}
                            className="scroll-x-drag"
                            ref={refs.scrollRefX}
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                height: '13px',
                                width: '100%',
                                background: '#d4d0c8',
                                cursor: 'pointer'
                            }}></div>
                    </div>
                    <button className="right-scroll-button" onClick={handleRightClickX}>
                        <svg width="6" height="6" viewBox="0 0 6 6">
                            <polygon points="0,0 6,3 0,6" fill="black" />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="pens_tun" style={{ display: 'flex', height: '20px', marginLeft: '15px' }}>
                {props.pens.map((item, i) => {
                    if (item.name) {
                        const nameParam = item.name.split('/').pop();
                        if (nameParam) {
                            const param = nameParam.split('.');
                            if (param.length > 1) {
                                const Name = param[1];
                                return (
                                    <div
                                        key={i}
                                        style={{
                                            color: item.color,
                                            marginTop: '2px',
                                            marginRight: '15px',
                                            fontWeight: 'bold',
                                            fontFamily: 'Courier New, Courier, monospace',
                                            fontSize: '0.8em'
                                        }}>
                                        {Name}
                                    </div>
                                );
                            }
                        }
                    }
                    return null;
                })}
            </div>
        </div>
    );
});

export default TuningGraph;
